export const downloadCSV = (csvString: BlobPart, fileName: string) => {
  const blob = new Blob([csvString]);
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${fileName}.csv`;
  a.click();
  window.URL.revokeObjectURL(url);
};
